import {initDropMenuNavigation} from './menu';
import {initMobileMenu} from './mobile';

document.addEventListener("DOMContentLoaded", function () {
    initDropMenuNavigation(".js-subnav", ".subnav-content");
    initMobileMenu();
});

